module.exports = __webpack_public_path__ + "static/SG_Twilio_Lockup_Social-56f3cfd2f6b0c62422980170d57fac64.png";